import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/retail1.jpg";
import retailThumb from "../img/retail.jpg";
import "../style/styles.css";
import "../style/Retail.css";

const Retails = () => {
  const heroStats = [
    { value: "POS", label: "Touch Billing" },
    { value: "GST", label: "Ready Invoices" },
    { value: "Stock", label: "Live Inventory" },
    { value: "MIS", label: "Business Reports" },
  ];

  const coreFeatures = [
    {
      title: "Retail Billing",
      text:
        "Fast and user-friendly billing with multiple payment support, detailed invoice printing and real-time inventory update after every sale.",
    },
    {
      title: "Credit GST Billing",
      text:
        "GST-compliant credit billing with accurate tax calculation, transparent ledger impact and simplified financial control.",
    },
    {
      title: "Purchase Billing",
      text:
        "Simplified inward goods entry from suppliers with automatic stock update and accurate purchase tracking.",
    },
    {
      title: "Stock Adjustment",
      text:
        "Reconcile system stock with physical stock through controlled adjustment entries and complete stock movement records.",
    },
    {
      title: "Physical Stock Taking",
      text:
        "Tools to perform physical stock count and compare actual inventory with system inventory for better stock accuracy.",
    },
    {
      title: "Minimum Stock Alerts",
      text:
        "Automated minimum stock alerts help prevent stockouts and support timely replenishment of fast-moving items.",
    },
  ];

  const inventoryFeatures = [
    "Stock Summary with real-time item availability",
    "Closing Stock Reporting for financial control",
    "High-Value Item Tracking for better monitoring",
    "Dead Stock Management for slow-moving items",
    "Product Ledger with complete item movement history",
  ];

  const reports = [
    "Daily and monthly product sales details",
    "Graphical sales and purchase analysis",
    "Back office dashboard with real-time indicators",
    "Minimum stock level tracking",
    "Profitability and stock performance reports",
  ];

  const benefits = [
    "Touchscreen-ready retail interface",
    "Integrated billing and inventory workflow",
    "Real-time stock visibility",
    "Improved customer billing speed",
    "Better purchase and stock control",
    "Role-based user security",
  ];

  const seoKeywords = [
    "Retail POS Software",
    "Retail Billing Software",
    "Retail Management Software",
    "Retail Outlet Software",
    "Retail Inventory Software",
    "GST Billing Software",
    "GST Retail Billing Software",
    "Touch Screen Billing Software",
    "Point of Sale Software",
    "POS Billing Software",
    "Inventory Management Software",
    "Stock Management Software",
    "Purchase Billing Software",
    "Product Ledger Software",
    "Physical Stock Taking Software",
    "Minimum Stock Alert Software",
    "Dead Stock Management Software",
    "High Value Stock Tracking Software",
    "MIS Report Software",
    "Retail Accounting Software",
    "Barcode Billing Software",
    "Supermarket Billing Software",
    "Grocery Store Billing Software",
    "Garments Store Billing Software",
    "Footwear Store Billing Software",
    "Electronics Store Billing Software",
    "Mobile Shop Billing Software",
    "Departmental Store Software",
    "General Store Billing Software",
    "Hardware Store Billing Software",
    "Cosmetics Store Billing Software",
    "Stationery Shop Billing Software",
    "Book Store Billing Software",
    "Gift Shop Billing Software",
    "Retail Software in India",
    "Retail Billing Software in India",
    "POS Software in India",
    "Retail Software in Siliguri",
    "Retail Software in West Bengal",
  ];

  const relatedSearchGroups = [
    {
      title: "Retail POS & GST Billing",
      text:
        "SaleSync supports retail outlets with fast POS billing, GST invoices, credit billing, touchscreen billing and customer-friendly checkout operations.",
      terms: [
        "Retail POS Software",
        "Retail Billing Software",
        "Retail Management Software",
        "Retail Outlet Software",
        "GST Billing Software",
        "GST Retail Billing Software",
        "Touch Screen Billing Software",
        "Point of Sale Software",
        "POS Billing Software",
        "Credit GST Billing Software",
        "Retail Invoice Software",
        "Counter Billing Software",
      ],
    },
    {
      title: "Inventory, Stock & Purchase Control",
      text:
        "SaleSync helps businesses control stock, purchase entries, physical stock verification, dead stock, high-value items, product ledger and minimum stock alerts.",
      terms: [
        "Retail Inventory Software",
        "Inventory Management Software",
        "Stock Management Software",
        "Purchase Billing Software",
        "Product Ledger Software",
        "Physical Stock Taking Software",
        "Minimum Stock Alert Software",
        "Dead Stock Management Software",
        "High Value Stock Tracking Software",
        "Closing Stock Report Software",
        "Stock Adjustment Software",
        "Supplier Purchase Software",
      ],
    },
    {
      title: "Retail Reports, MIS & Security",
      text:
        "SaleSync provides useful MIS reports, graphical analysis, dashboard reporting, sales reports, purchase reports, stock reports and user-wise access control.",
      terms: [
        "MIS Report Software",
        "Retail MIS Software",
        "Retail Dashboard Software",
        "Sales Report Software",
        "Purchase Report Software",
        "Stock Report Software",
        "Retail Accounting Software",
        "Retail Business Report Software",
        "Retail Profitability Report Software",
        "Role Based Security Software",
        "User Access Control Software",
        "Back Office Retail Software",
      ],
    },
    {
      title: "Retail Software for Various Outlets",
      text:
        "SaleSync is suitable for different retail outlets such as supermarkets, grocery stores, garments shops, footwear shops, electronics stores, mobile shops and departmental stores.",
      terms: [
        "Supermarket Billing Software",
        "Grocery Store Billing Software",
        "Garments Store Billing Software",
        "Footwear Store Billing Software",
        "Electronics Store Billing Software",
        "Mobile Shop Billing Software",
        "Departmental Store Software",
        "General Store Billing Software",
        "Hardware Store Billing Software",
        "Cosmetics Store Billing Software",
        "Stationery Shop Billing Software",
        "Book Store Billing Software",
        "Gift Shop Billing Software",
        "Boutique Billing Software",
        "Multi Outlet Retail Software",
        "Small Business Billing Software",
      ],
    },
    {
      title: "Retail Software by Location",
      text:
        "SaleSync is useful for retail businesses looking for POS billing, GST billing, inventory and retail management software in Siliguri, West Bengal and India.",
      terms: [
        "Retail Software in India",
        "Retail Billing Software in India",
        "POS Software in India",
        "GST Billing Software in India",
        "Inventory Software in India",
        "Retail Software in Siliguri",
        "Retail Billing Software in Siliguri",
        "POS Software in Siliguri",
        "Retail Software in West Bengal",
        "Retail Billing Software in West Bengal",
        "Retail Software Company in Siliguri",
        "Retail Software Developer in West Bengal",
      ],
    },
  ];

  const seoPainPoints = [
    {
      title: "Faster billing for busy retail counters",
      text:
        "SaleSync helps retail outlets complete billing quickly with a touch-enabled POS workflow, GST invoice support and real-time stock update after every sale.",
    },
    {
      title: "Better control over stock and purchases",
      text:
        "SaleSync manages purchase billing, stock adjustment, physical stock taking, product ledger, closing stock and minimum stock alerts for better retail inventory control.",
    },
    {
      title: "Clear MIS reports for business decisions",
      text:
        "SaleSync provides sales reports, purchase analysis, stock reports, graphical business analysis and dashboard indicators for better owner-level visibility.",
    },
    {
      title: "Secure retail operations",
      text:
        "SaleSync supports role-based user security and controlled business entries so retail staff can access only the operations permitted for their responsibility.",
    },
  ];

  const faqList = [
    {
      question: "What is SaleSync retail POS software?",
      answer:
        "SaleSync is a GST-ready retail POS and inventory management software for retail outlets. It manages billing, credit GST billing, purchase billing, stock adjustment, physical stock taking, minimum stock alerts, MIS reports and user security.",
    },
    {
      question: "Is SaleSync suitable for different retail outlets?",
      answer:
        "Yes. SaleSync is suitable for supermarkets, grocery stores, garments shops, footwear shops, electronics stores, mobile shops, departmental stores, general stores, stationery shops and other retail businesses.",
    },
    {
      question: "Does SaleSync manage inventory and stock reports?",
      answer:
        "Yes. SaleSync supports stock summary, closing stock, high-value item tracking, dead stock management, product ledger, stock adjustment and physical stock verification.",
    },
    {
      question: "Does SaleSync support GST billing?",
      answer:
        "Yes. SaleSync supports GST-ready retail billing and credit GST billing with accurate tax calculation and invoice printing.",
    },
    {
      question: "Can SaleSync generate MIS reports?",
      answer:
        "Yes. SaleSync provides daily and monthly product sales reports, graphical sales and purchase analysis, back office dashboard reports, minimum stock tracking and stock performance reports.",
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath = "/Retails";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImageUrl = String(web5 || "").startsWith("http") ? web5 : `${siteUrl}${web5}`;

  const seoTitle =
    "Retail POS Software | SaleSync GST Billing, Inventory & Retail Management";

  const seoDescription =
    "SaleSync is a GST-ready retail POS software for billing, inventory, purchase, stock adjustment, physical stock taking, minimum stock alerts, MIS reports and secure retail outlet management.";

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "SaleSync",
    alternateName: "SaleSync Retail POS and Inventory Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Windows, Web",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    brand: {
      "@type": "Brand",
      name: "SaleSync",
    },
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      description: "Contact EBS Software Solution for SaleSync demo and pricing.",
    },
    featureList: [
      "Retail POS billing",
      "GST-ready invoice printing",
      "Credit GST billing",
      "Purchase billing",
      "Inventory and stock management",
      "Stock adjustment",
      "Physical stock taking",
      "Minimum stock alerts",
      "Stock summary and product ledger",
      "High-value item tracking",
      "Dead stock management",
      "MIS reports and graphical analysis",
      "Role-based user security",
    ],
    keywords: seoKeywords.join(", "),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "SaleSync Retail POS Software",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = retailThumb;
  };

  return (
    <main className="retail-detail-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([softwareSchema, faqSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="retail-hero">
        <img
          className="retail-hero-bg"
          src={web5}
          alt="SaleSync retail POS software for GST billing inventory stock management and MIS reports"
          onError={handleImageError}
        />
        <div className="retail-hero-overlay"></div>

        <Container className="retail-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="retail-hero-content">
                <div className="retail-kicker">Retail POS & Inventory Software</div>
                <h1>SaleSync</h1>
                <h2>GST Ready Touch Enabled Retail POS Software</h2>
                <p>
                  SaleSync is a modern retail POS software and inventory
                  management system designed for retail outlets, supermarkets,
                  grocery stores, garments shops, footwear shops, electronics
                  stores and other businesses that need fast billing, GST
                  invoices, stock control, purchase tracking and MIS reports.
                </p>

                <div className="retail-hero-actions">
                  <a href="#retail-features" className="retail-btn retail-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="retail-btn retail-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="retail-hero-card">
                <img
                  src={retailThumb}
                  alt="SaleSync retail POS billing and inventory software"
                  onError={handleImageError}
                />
                <div>
                  <span>Advanced Retail Billing</span>
                  <strong>Inventory + POS + GST + MIS</strong>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="retail-stats-section">
        <Container>
          <Row className="g-3">
            {heroStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="retail-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="retail-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="retail-section-label">Overview</div>
              <h2 className="retail-section-title">
                Advanced retail billing and inventory management system
              </h2>
              <p className="retail-text">
                SaleSync is a comprehensive retail management software designed
                to streamline billing, optimize inventory management and provide
                meaningful business analytics. It helps businesses handle POS
                billing, GST invoices, stock tracking, purchase billing and
                reporting while maintaining strong data control and operational
                security.
              </p>
              <p className="retail-text">
                The system is suitable for retail outlets that need fast
                billing, GST-compliant invoices, purchase entry, stock
                adjustment, physical stock verification, minimum stock alerts,
                product ledger, closing stock reports and detailed MIS reports.
              </p>
            </Col>

            <Col lg={6}>
              <div className="retail-benefit-panel">
                <h3>Why SaleSync?</h3>
                <div className="retail-benefit-grid">
                  {benefits.map((item) => (
                    <div key={item}>
                      <span>✓</span>
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="retail-seo-section">
        <Container>
          <div className="retail-heading-center">
            <div className="retail-section-label">Why Retailers Choose SaleSync</div>
            <h2 className="retail-section-title">
              Retail POS software built for billing, inventory, purchase and MIS reports
            </h2>
            <p>
              SaleSync is designed for retail businesses that need faster
              billing, GST-ready invoices, live stock control, purchase
              tracking, minimum stock alerts, MIS reports and secure user-wise
              access control.
            </p>
          </div>

          <Row className="g-4">
            {seoPainPoints.map((item) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="retail-seo-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="retail-features-section" id="retail-features">
        <Container>
          <div className="retail-heading-center">
            <div className="retail-section-label">Core Features</div>
            <h2 className="retail-section-title">
              Everything required to manage a retail outlet
            </h2>
            <p>
              SaleSync combines billing, purchases, inventory, alerts, reporting
              and security in one practical retail management system.
            </p>
          </div>

          <Row className="g-4">
            {coreFeatures.map((feature, index) => (
              <Col lg={4} md={6} key={feature.title}>
                <div className="retail-feature-card">
                  <div className="retail-feature-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="retail-modules-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="retail-module-card">
                <div className="retail-section-label">Inventory Management</div>
                <h2>Complete stock control</h2>
                <p>
                  SaleSync provides complete inventory visibility with stock
                  summary, product ledger, closing stock, high-value item
                  tracking and dead stock monitoring.
                </p>

                <ul>
                  {inventoryFeatures.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="retail-module-card retail-module-card-dark">
                <div className="retail-section-label">MIS Reports</div>
                <h2>Insightful business reporting</h2>
                <p>
                  Management reports help business owners understand sales,
                  stock movement, purchase trends and item performance with
                  better clarity.
                </p>

                <ul>
                  {reports.map((item) => (
                    <li key={item}>
                      <span>✓</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="retail-security-section">
        <Container>
          <div className="retail-security-card">
            <Row className="align-items-center g-4">
              <Col lg={7}>
                <div className="retail-section-label">Security & Control</div>
                <h2>Role-based user-to-user security</h2>
                <p>
                  SaleSync includes entry-level security features with
                  role-based access control so users can access only the
                  operations and reports permitted for their responsibilities.
                  This helps protect sensitive business data and maintain
                  operational discipline.
                </p>
              </Col>

              <Col lg={5}>
                <div className="retail-security-list">
                  <div>
                    <strong>Access Control</strong>
                    <span>User-wise permissions</span>
                  </div>
                  <div>
                    <strong>Data Integrity</strong>
                    <span>Controlled business entries</span>
                  </div>
                  <div>
                    <strong>Business Safety</strong>
                    <span>Secure operational workflow</span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="retail-faq-section">
        <Container>
          <div className="retail-heading-center">
            <div className="retail-section-label">FAQ</div>
            <h2 className="retail-section-title">
              Questions about SaleSync retail POS software
            </h2>
            <p>
              Important information for retail businesses looking for POS
              billing, GST billing, inventory, stock control, MIS reports and
              retail outlet management software.
            </p>
          </div>

          <div className="retail-faq-list">
            {faqList.map((item) => (
              <div className="retail-faq-item" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="retail-cta-section">
        <Container>
          <div className="retail-cta-card">
            <div>
              <span>Ready to modernize your retail outlet?</span>
              <h2>Use SaleSync for billing, inventory and reporting.</h2>
              <p>
                SaleSync helps retail businesses improve billing speed,
                inventory accuracy, GST invoice control, stock visibility and
                management reporting from one platform.
              </p>
            </div>
            <Link to="/EmailContactForm" className="retail-btn retail-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="retail-corporate-keywords-section">
        <Container>
          <div className="retail-corporate-keywords-head">
            <div className="retail-section-label">Related Solutions</div>
            <h2>Retail POS, GST billing, inventory and outlet software search terms</h2>
            <p>
              SaleSync covers important retail software requirements with
              professional POS billing, GST invoices, stock management, purchase
              billing, MIS reports, security and outlet-wise retail operations.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="retail-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="retail-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default Retails;